// console.log("process.env.NODE_ENV", process.env.NODE_ENV);
// var baseUrl;
// switch (process.env.NODE_ENV) {
//   case "development":
//     baseUrl = baseUrl; // 测试环境url
//     break;
//   case "pre":
//     baseUrl = "https://www.mtu.plus"; // 预上线环境url
//     break;
//   case "production":
//     baseUrl = "https://www.mtu.plus"; // 生产环境url
//     break;
// }
function getUrl() {
  // console.log("get baseurl", this);
  return this.baseurl || "";
}
function setUrl(url) {
  console.log("set Baseurl", url);
  this.baseurl = url || "";
}
export default {
  getUrl,
  setUrl
};
